import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { GbYesNoSnackBarComponent } from './components/gb-yes-no-snack-bar/gb-yes-no-snack-bar.component'
import { GbOfflineSnackBarComponent } from './components/gb-offline-snack-bar/gb-offline-snack-bar.component'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

@NgModule({
  imports: [CommonModule, MatSnackBarModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  declarations: [GbYesNoSnackBarComponent, GbOfflineSnackBarComponent],
  exports: [MatSnackBarModule],
})
export class SharedUtilsNotificationModule {}
